/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.20.1.0 (NJsonSchema v9.11.0.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class IdentityManagementService {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Creates new identity
     * @param identityDto New identity
     * @return Cre
     */
    createIdentity(identityDto: NewIdentityDto | null): Promise<IdentityDto | null> {
        let url_ = this.baseUrl + "/api/v1/iam/identities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(identityDto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateIdentity(_response);
        });
    }

    protected processCreateIdentity(response: Response): Promise<IdentityDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IdentityDto.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityDto | null>(<any>null);
    }

    /**
     * Gets identities array
     * @return Array of identities
     */
    getIdentities(): Promise<IdentityDto[] | null> {
        let url_ = this.baseUrl + "/api/v1/iam/identities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIdentities(_response);
        });
    }

    protected processGetIdentities(response: Response): Promise<IdentityDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(IdentityDto.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityDto[] | null>(<any>null);
    }

    /**
     * Gets identity by identificator
     * @param id identity id
     * @return The identity
     */
    getIdentity(id: string): Promise<Identity | null> {
        let url_ = this.baseUrl + "/api/v1/iam/identities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIdentity(_response);
        });
    }

    protected processGetIdentity(response: Response): Promise<Identity | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Identity.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Identity | null>(<any>null);
    }

    /**
     * Deletes identity
     * @param id identity id
     * @return No content if identity deleted
     */
    deleteIdentity(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/iam/identities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteIdentity(_response);
        });
    }

    protected processDeleteIdentity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IdentityDto implements IIdentityDto {
    id?: string | undefined;
    userId!: string;
    name?: string | undefined;
    description?: string | undefined;
    identityType?: string | undefined;
    identityClaims?: string | undefined;
    creationTime!: Date;

    constructor(data?: IIdentityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.description = data["description"];
            this.identityType = data["identityType"];
            this.identityClaims = data["identityClaims"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IdentityDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["IdentityType"] = this.identityType;
        data["IdentityClaims"] = this.identityClaims;
        data["CreationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IIdentityDto {
    id?: string | undefined;
    userId: string;
    name?: string | undefined;
    description?: string | undefined;
    identityType?: string | undefined;
    identityClaims?: string | undefined;
    creationTime: Date;
}

export class NewIdentityDto implements INewIdentityDto {
    name?: string | undefined;
    description?: string | undefined;
    identityType?: string | undefined;
    identityClaims?: string | undefined;

    constructor(data?: INewIdentityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["Name"];
            this.description = data["Description"];
            this.identityType = data["IdentityType"];
            this.identityClaims = data["IdentityClaims"];
        }
    }

    static fromJS(data: any): NewIdentityDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewIdentityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["IdentityType"] = this.identityType;
        data["IdentityClaims"] = this.identityClaims;
        return data; 
    }
}

export interface INewIdentityDto {
    name?: string | undefined;
    description?: string | undefined;
    identityType?: string | undefined;
    identityClaims?: string | undefined;
}

export class Identity implements IIdentity {
    id?: string | undefined;
    userId!: string;
    name?: string | undefined;
    description?: string | undefined;
    identityType?: string | undefined;
    identityClaims?: string | undefined;
    creationTime!: Date;

    constructor(data?: IIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["Id"];
            this.userId = data["UserId"];
            this.name = data["Name"];
            this.description = data["Description"];
            this.identityType = data["IdentityType"];
            this.identityClaims = data["IdentityClaims"];
            this.creationTime = data["CreationTime"] ? new Date(data["CreationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Identity {
        data = typeof data === 'object' ? data : {};
        let result = new Identity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserId"] = this.userId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["IdentityType"] = this.identityType;
        data["IdentityClaims"] = this.identityClaims;
        data["CreationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IIdentity {
    id?: string | undefined;
    userId: string;
    name?: string | undefined;
    description?: string | undefined;
    identityType?: string | undefined;
    identityClaims?: string | undefined;
    creationTime: Date;
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if(result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}


// WEBPACK FOOTER //
// ./src/services/identity.service.ts